import {isDraft} from '@wix/wix-events-commons-statics'
import {Spinner} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {RsvpButtonStyleProps} from './interfaces'
import s from './registration-button-skin.scss'
import {classes} from './registration-button-skin.st.css'

const getButtonClasses = (secondary: boolean, disabled: boolean, narrowerButton: boolean) => {
  const className = [s.registrationButton]
  className.push(secondary ? s.secondary : s.primary)

  if (disabled) {
    className.push(s.disabled)
  }

  if (narrowerButton) {
    className.push(s.narrowerButton)
  }

  return classNames(...className)
}

export const RegistrationButtonSkin = ({
  onClick,
  url,
  isExternalLink,
  text,
  dataHook,
  secondary,
  disabled,
  minWidth,
  minHeight,
  narrowerButton,
  spinner,
}: RsvpButtonStyleProps) => {
  const event = useAppSelector(getEvent)

  const draftEvent = !!event && isDraft(event)
  const buttonClasses = getButtonClasses(secondary, disabled, narrowerButton)
  const style = {minWidth, minHeight}

  let rel = isExternalLink ? 'nofollow' : ''

  const content = spinner ? (
    <div className={classes.spinnerContainer}>
      <Spinner className={classes.spinner} diameter={20} />
    </div>
  ) : (
    text
  )

  if (draftEvent) {
    rel = 'noreferrer'
  }

  return url && !disabled ? (
    <a
      data-hook={dataHook}
      className={classNames(buttonClasses, s.link)}
      href={url}
      style={style}
      rel={rel}
      target={draftEvent ? '_blank' : undefined}
    >
      {content}
    </a>
  ) : (
    <button data-hook={dataHook} className={buttonClasses} onClick={onClick} disabled={disabled} style={style}>
      {content}
    </button>
  )
}
